import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Button } from "@natera/form";
import { AuthTitle, NeedHelpLink } from "@app/components";
import { DobVerificationForm } from "@app/components/forms";
import { DateOfBirthSubmitProps } from "@app/components/forms/dobVerificationForm/dobVerificationForm";
import { usePortalRedirects } from "@app/hooks";
import { HeapEventProps } from "@app/components/linkHeap/linkHeap";
import { HEAP_EVENTS } from "@app/provider/types";

import "./dateOfBirthVerification.scss";

const messages = defineMessages({
  welcomeBloodDrawDobTitle: {
    id: "welcomeBloodDrawDobTitle",
    defaultMessage: "Welcome to Natera’s Patient Portal",
  },
  welcomeBloodDrawDobSubTitle: {
    id: "welcomeBloodDrawDobSubTitle",
    defaultMessage: "Please enter your date of birth to proceed.",
  },
  welcomeBloodDrawDobHaveAccountBtn: {
    id: "welcomeBloodDrawDobHaveAccountBtn",
    defaultMessage: "I already have an account",
  },
});

type DateOfBirthVerificationScreenProps = {
  loadingForm: boolean;
  onSubmitForm: (props: DateOfBirthSubmitProps) => Promise<void>;
  heapEventName: HEAP_EVENTS;
  heapEventProps: HeapEventProps;
  isPhoneRequired?: boolean;
  authTitle: React.ReactNode;
};

const DateOfBirthVerificationScreen: FC<DateOfBirthVerificationScreenProps> = ({
  loadingForm,
  onSubmitForm,
  heapEventName,
  heapEventProps,
  isPhoneRequired = false,
  authTitle,
}) => {
  const intl = useIntl();
  const { toLogin } = usePortalRedirects();

  return (
    <div className="dob-verification">
      <div className="dob-verification__container">
        {authTitle}
        <div className="dob-verification__form">
          <DobVerificationForm
            isPhoneRequired={isPhoneRequired}
            loading={loadingForm}
            onSubmit={onSubmitForm}
          />
        </div>
        <Button
          type="button"
          className="dob-verification__btn"
          outlined
          onClick={() => toLogin({ preserveQuery: false })}
        >
          {intl.formatMessage(messages.welcomeBloodDrawDobHaveAccountBtn)}
        </Button>
        <NeedHelpLink
          heapEventName={heapEventName}
          heapEventProps={heapEventProps}
        />
      </div>
    </div>
  );
};

export default DateOfBirthVerificationScreen;
